import React from "react";

const SideDrawer = ({
  open,
  onClose,
  title,
  titleIcon,
  titleHint,
  ariaLabel,
  children,
  zIndexClass = "z-[1250]",
}) => {
  return (
    <div
      className={`fixed inset-0 ${zIndexClass} ${
        open ? "pointer-events-auto" : "pointer-events-none"
      }`}
      aria-hidden={!open}
    >
      <div
        className={`absolute inset-0 bg-black/30 transition-opacity duration-300 ${
          open ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />
      <div
        className={`absolute right-0 top-0 h-full max-h-screen w-full mobile:w-full tablet:w-[28rem] laptop:w-[32rem] desktop:w-[36rem] bg-white border-l border-gray-200 transform transition-transform duration-300 ${
          open ? "translate-x-0" : "translate-x-full"
        } flex flex-col min-h-0 overflow-hidden`}
        role="dialog"
        aria-label={ariaLabel || title}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <div className="flex items-center gap-2 min-w-0">
            {titleIcon ? (
              <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-secondary-green/10 text-secondary-green shrink-0">
                {titleIcon}
              </span>
            ) : null}
            <div className="min-w-0">
              <h3 className="text-lg font-bold text-gray-900 truncate">{title}</h3>
              {titleHint ? (
                <p className="text-xs text-gray-500 mt-0.5">{titleHint}</p>
              ) : null}
            </div>
          </div>
          <button
            type="button"
            className="inline-flex items-center justify-center w-9 h-9 rounded-lg hover:bg-gray-100 focus:outline-none"
            onClick={onClose}
          >
            <img
              src="/assets/icons/Dolj.png"
              alt="Close"
              className="w-5 h-5 text-gray-600"
            />
          </button>
        </div>
        <div className="flex-1 min-h-0 overflow-y-auto p-4 pb-24">{children}</div>
      </div>
    </div>
  );
};

export default SideDrawer;
